import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, StandAloneLink, Txt } from '@vst/beam';
import { Close, ErrorOutline } from '@vst/beam-icons/icons';

import { selectStreamOnPromo, setOrderFail, submitFullOrder } from '@app/redux/streamOnPromo';

import { AddressInput } from '@mfe/shared/schema-types';

import { useTranslation } from '../../utils';

import styles from './styles.module.scss';

const MAX_ATTEMPTS = 3;

export const ErrorToast = () => {
  const { t } = useTranslation('ToastError');
  const dispatch = useDispatch();

  const { shippingAddress, isEditingNumber, userDetails, didOrderFail, orderAttempts } =
    useSelector(selectStreamOnPromo);

  const toastRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    toastRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const handleRetry = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatch(
      submitFullOrder({
        address: shippingAddress as AddressInput,
        isEditingNumber,
        phoneNumber: userDetails?.phoneNumber,
      })
    );
  };

  return (
    <div className={styles['wrapperToast']}>
      <div className={styles['toastContainer']} ref={toastRef} data-cy="errorToast">
        <div className={styles['iconContainer']}>
          <Icon icon={ErrorOutline} color="alert_300" data-cy="errorToastExclamationMark" />
        </div>
        <div className={styles['textContainer']}>
          <div className={styles['title']}>
            <Txt variant="bodyLargeBold" className={styles['titleText']} data-cy="errorToastTitle">
              {orderAttempts >= MAX_ATTEMPTS ? t('TryLater.Title') : t('Title')}
            </Txt>
          </div>
          <div className={styles['subtitle']} data-cy="errorToastSubTitle">
            <Txt variant="bodySmallRegular">
              {orderAttempts >= MAX_ATTEMPTS ? t('TryLater.SubTitle') : t('SubTitle')}
            </Txt>
          </div>
          <div className={styles['actionLink']}>
            {orderAttempts < MAX_ATTEMPTS && (
              <StandAloneLink
                variant="primary"
                linkSize="medium"
                href=""
                onClick={handleRetry}
                className={styles['linkText']}
                data-cy="retryErrorToastRequest"
              >
                {t('Retry')}
              </StandAloneLink>
            )}
          </div>
        </div>
        <div className={styles['closeButtonContainer']}>
          <Icon
            icon={Close}
            color="gray_700"
            onClick={() => dispatch(setOrderFail(didOrderFail?.failureReason ?? ''))}
            className={styles['closeButton']}
            data-cy="errorToastCloseButton"
          />
        </div>
      </div>
    </div>
  );
};
